const LinkedInIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#0A66C2" width="20" height="20">
      <path d="M100.28 448H7.4V149.5h92.88zm-46.44-323a53.67 53.67 0 1153.67-53.67 53.67 53.67 0 01-53.67 53.67zM447.9 448h-92.68V302.4c0-34.68-12.39-58.34-43.52-58.34-23.73 0-37.87 16-44.09 31.44-2.27 5.52-2.84 13.2-2.84 20.88V448H172.11s1.24-271.6 0-299.5h92.68v42.48c12.33-19 34.36-46.28 83.42-46.28 60.91 0 106.69 39.78 106.69 125.22z" />
    </svg>
  );
  
  export default LinkedInIcon;
  